export default "__VITE_PUBLIC_ASSET__c84302e0__"